/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Checkbox,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormControl,
} from '@material-ui/core';
import clsx from 'clsx';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithoutBox';
import Fieldset from './Fieldset';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import * as commonConstant from '../../../../SharedModules/CommonConstants/commonConstants';

import {
  getBalanceThreshold,
  getManufacturerList,
  getPlanTypeValues,
  getRebateProgrameList,
  setSearchInput,
  getDramsInvStartQtr,
  getEarliestDrugQtr,
  setManufactureList,
  getQuarterlyPayment,
  getQuarterlyPaymentForAllMfg,
} from '../Store/actions';
import { ManufactureTableHead } from './tableHeads';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  NO_DATA,
  MANUFACTURER_IS_REQUIRED,
  REBATE_PROGRAM_REQUIRED,
} from '../../../../SharedModules/Errors/constantMessageData';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

const RequestQuarterlyPayment = (props) => {
  const gridRef = useRef();
  const dispatch = useDispatch();

  const {
    isLoading,
    planType: planTypeList,
    rebateProgramList: rebateProgramListData = [],
    manufacturerList: manufactureListData,
    threshold,
    useBalanceThreshold,
    rebateProgram: rebateProgramValue,
    reportQuarter: reportQuarterValue,
    plan,
    invoiceNum,
    isAll,
    errorMessages,
    dramsInvoice,
    earliestQtr,
    searchResult,
  } = useSelector((state) => state?.sharedState?.QuarterlyPaymentsReducer);

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [errorList, setErrorList] = React.useState(errorMessages);

  const [manufactureList, setManufacturerList] = React.useState([]);

  const [fullScreenView, setFullScreenView] = React.useState(false);

  const [planType, setPlanType] = React.useState(plan);

  const [isSearchClicked, setSearchClicked] = React.useState(false);

  const [selectList, setSelectList] = React.useState([]);

  const [radioList, setRadioList] = React.useState([]);

  const [selectedRows, setSelectedRows] = React.useState([]);
  const defaultReportQuarter =
    userDefaults?.defRptQtrSelectCd === 'D'
      ? 'DRAMS Invoice Start Quarter'
      : userDefaults?.defRptQtrSelectCd === 'E'
      ? 'Earliest Quarter for Drug Details'
      : 'All';
  const [reportQuarter, setReportQuarter] = React.useState(
    reportQuarterValue || defaultReportQuarter
  );

  const [c, setC] = React.useState(0);

  const [reportQuarterOption, setReportQuarterOption] = React.useState([
    {
      name: 'All',
      value: 'All',
      disabled: false,
    },
    {
      name: 'DRAMS Invoice Start Quarter',
      value: 'DRAMS Invoice Start Quarter',
      disabled: false,
    },
    {
      name: 'Earliest Quarter for Drug Details',
      value: 'Earliest Quarter for Drug Details',
      disabled: false,
    },
  ]);

  const [checkboxValues, setCheckboxValues] = React.useState({
    isAllManufacturersSelected: isAll,
    isBalanceDueThreshold: useBalanceThreshold,
  });
  const [rebateProgram, setRebateProgram] = React.useState(rebateProgramValue);
  const [thresholdValue, setThresholdValue] = React.useState(threshold);
  const [isThreshold, setIsThreshold] = React.useState(false);
  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData?.map((val) => ({
      ...val,
      id: val?.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));

    // if (list.length) {
    setSelectList(list);

    const tempRebateProgram = list?.find(
      (item) => item?.id === userDefaults?.rebateProgramCd
    );

    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');

    const errors = errorList?.filter(
      (error) => error.field !== 'rebateProgram'
    );

    setErrorList([...errors]);
    // }
  };
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList?.PLAN_TYPE_CD?.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
          shortDesc: obj.shortDescription,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList?.find(
        (item) => item?.value === userDefaults?.planTypeCd
      );
      setPlanType(plan || tempPlanType?.value);
    }
  }, [planTypeList]);

  React.useEffect(() => {
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
    }
  }, [planType]);

  // React.useEffect(() => {
  //   setErrorList(errorMessages);
  // }, [errorMessages]);

  React.useEffect(() => {
    const errors = errorList?.filter((error) => error.field !== 'noData');
    if (manufactureListData?.length === 0 && c > 1) {
      errors.push({
        field: 'noData',
        message: NO_DATA,
      });
    }

    setC(c + 1);

    setErrorList([...errors]);

    setManufacturerList(manufactureListData);
  }, [manufactureListData]);

  // dispatch mfg list API
  React.useEffect(() => {
    if (planType) {
      dispatch(
        getManufacturerList({
          planType: planType,
          asMode: 1,
        })
      );
    }
  }, [planType]);

  // on Changes rebateProgram API called
  React.useEffect(() => {
    dispatch(
      getDramsInvStartQtr({
        rebateProgCode: rebateProgram,
        allRpc: 0,
      })
    );
    dispatch(
      getEarliestDrugQtr({
        rebateProgramCd: rebateProgram,
      })
    );
  }, [rebateProgram]);

  // let tempQuarter = reportQuarter.find(
  //   (item) => item.id === userDefaults?.defRptQtrSelectCd
  // );
  // setReportQuarter(reportQuarter );

  // Threshold API is getting called from here
  React.useEffect(() => {
    dispatch(
      getBalanceThreshold({
        rebateProgramCd: rebateProgram,
      })
    );
  }, [rebateProgram]);

  // select row one by one in manufacturer table grid
  const onRowSelect = (rowData) => {
    const newObj = manufactureListData?.map((item) => {
      if (
        rowData?.filter((x) => {
          return x.mfgId === item.mfgId;
        }).length > 0
      ) {
        item.value = true;
      } else {
        item.value = false;
      }
      return item;
    });
    dispatch(setManufactureList(newObj));
  };

  React.useEffect(() => {
    setThresholdValue(thresholdValue);
  }, [thresholdValue]);

  const changeFullScreenView = () => setFullScreenView(!fullScreenView);

  // Handles the validation and if all is fine navigate to display screend
  const handleSearchClick = async (e, onDoubleClick, onDoubleClickData) => {
    let sRows =
      (checkboxValues?.isAllManufacturersSelected
        ? manufactureList
        : onDoubleClick
        ? onDoubleClickData
        : selectedRows) || [];

    const errors = [];

    if (sRows.length === 0 && !checkboxValues.isAllManufacturersSelected) {
      errors.push({
        field: 'manufactureSelect',
        message: MANUFACTURER_IS_REQUIRED,
      });
    }

    if (rebateProgram === '-1') {
      errors.push({
        field: 'rebateProgram',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }

    setErrorList(errors);
    // if (sRows.length === 1 && errors.length == 0) {
    //   sRows.sort((a, b) =>
    //     a.mfgId > b.mfgId ? 1 : b.mfgId > a.mfgId ? -1 : 0
    //   );
    //   setSearchClicked(true);
    //   let rebateProgrameName =
    //     selectList.find((item) => item.rebateProgramCd === rebateProgram) || {};
    //   rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${
    //     rebateProgrameName?.shortDescr || ''
    //   }`;
    //   dispatch(
    //     setSearchInput({
    //       selectedPlanType: radioList.find((item) => item.value === planType)
    //         ?.shortDesc,
    //       rebateProgram,
    //       selectedRows: sRows,
    //       reportQuarter,
    //       useBalanceThreshold: checkboxValues.isBalanceDueThreshold,
    //       plan: planType,
    //       isAll: checkboxValues.isAllManufacturersSelected,
    //       errorMessages: errors,
    //       rebateProgrameName,
    //       displayObj: {
    //         selectedPlanType: radioList?.find((item) => item.value === planType)
    //           ?.shortDesc,
    //         rebateProgram,
    //         selectedRows: sRows,
    //         reportQuarter,
    //         rebateProgrameName,
    //         useBalanceThreshold: checkboxValues.isBalanceDueThreshold,
    //         plan: planType,
    //         isAll: checkboxValues.isAllManufacturersSelected,
    //         dramsInvoice,
    //         earliestQtr,
    //         rebateProgramList: rebateProgramListData,
    //       },
    //     })
    //   );

    //   if (sRows[0]?.mfgId) {
    //     dispatch(
    //       getQuarterlyPayment({
    //         rebateProgramCd: rebateProgram,
    //         quarter:
    //           reportQuarter === 'All'
    //             ? '1Q1991'
    //             : reportQuarter === 'DRAMS Invoice Start Quarter'
    //             ? dramsInvoice
    //             : reportQuarter === 'Earliest Quarter for Drug Details'
    //             ? earliestQtr
    //             : '',
    //         mfgIds: [sRows[0]?.mfgId],
    //         thresh: useBalanceThreshold ? threshold : 0,
    //       })
    //     );
    //   }
    // }

    if (errors.length == 0) {
      if (checkboxValues.isAllManufacturersSelected) {
        const res = await dispatch(
          getQuarterlyPaymentForAllMfg({
            rebateProgramCd: rebateProgram,
            quarter:
              reportQuarter === 'All'
                ? '1Q1991'
                : reportQuarter === 'DRAMS Invoice Start Quarter'
                ? dramsInvoice
                : reportQuarter === 'Earliest Quarter for Drug Details'
                ? earliestQtr
                : '',
            mfgIds: [],
            allLabelers: 'Y',
            thresh: isThreshold
              ? null
              : useBalanceThreshold
              ? threshold || 0
              : 0,
          })
        );
        if (res?.length)
          sRows = manufactureList.filter((obj) => res.indexOf(obj.mfgId) >= 0);
      }
      sRows.sort((a, b) =>
        a.mfgId > b.mfgId ? 1 : b.mfgId > a.mfgId ? -1 : 0
      );
      setSearchClicked(true);
      let rebateProgrameName =
        selectList.find((item) => item.rebateProgramCd === rebateProgram) || {};
      rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${
        rebateProgrameName?.shortDescr || ''
      }`;
      dispatch(
        setSearchInput({
          selectedPlanType: radioList.find((item) => item.value === planType)
            ?.shortDesc,
          rebateProgram,
          selectedRows: sRows,
          reportQuarter,
          rebateProgrameName,
          useBalanceThreshold: checkboxValues.isBalanceDueThreshold,
          plan: planType,
          isAll: checkboxValues.isAllManufacturersSelected,
          errorMessages: errors,
          displayObj: {
            selectedPlanType: radioList?.find((item) => item.value === planType)
              ?.shortDesc,
            rebateProgram,
            selectedRows: sRows,
            reportQuarter,
            rebateProgrameName,
            useBalanceThreshold: checkboxValues.isBalanceDueThreshold,
            plan: planType,
            isAll: checkboxValues.isAllManufacturersSelected,
            dramsInvoice,
            earliestQtr,
            rebateProgramList: rebateProgramListData,
          },
        })
      );

      if (sRows[0]?.mfgId) {
        dispatch(clearReduxForFilterAndSort('/quarterlyPaymentDisplay'));
        const result = await dispatch(
          getQuarterlyPayment({
            rebateProgramCd: rebateProgram,
            quarter:
              reportQuarter === 'All'
                ? '1Q1991'
                : reportQuarter === 'DRAMS Invoice Start Quarter'
                ? dramsInvoice
                : reportQuarter === 'Earliest Quarter for Drug Details'
                ? earliestQtr
                : '',
            mfgIds: [sRows[0]?.mfgId],
            thresh: isThreshold
              ? null
              : useBalanceThreshold
              ? threshold || 0
              : 0,
          })
        );
        if (result?.length) {
          const updateTabs =
            JSON.parse(localStorage.getItem('tabItemsData')) === null
              ? []
              : JSON.parse(localStorage.getItem('tabItemsData'));
          updateTabs.push({
            navTo: '/quarterlyPaymentDisplay',
            value: 'Display Quarterly Payment Report',
          });
          localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
          props.history.push({
            pathname: '/quarterlyPaymentDisplay',
          });
        }
      }
    }
    /*
        if all the  error is cleaered then it will go to if block and
        set store value and navigate to Displayy Screen
    * */
    if (errors.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  // For No Data validation
  React.useEffect(() => {
    setErrorList(errorMessages);
    if (isSearchClicked && errorMessages?.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [errorMessages]);

  // if (isSearchClicked && searchResult?.length > 0) {
  //   const updateTabs =
  //     JSON.parse(localStorage.getItem('tabItemsData')) === null
  //       ? []
  //       : JSON.parse(localStorage.getItem('tabItemsData'));

  //   updateTabs.push({
  //     navTo: '/quarterlyPaymentDisplay',

  //     value: 'Display Quarterly Payment Report',
  //   });

  //   localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));

  //   setSearchClicked(false);
  //   props.history.push({
  //     pathname: '/quarterlyPaymentDisplay',
  //   });
  //   dispatch(clearReduxForFilterAndSort('/quarterlyPaymentDisplay'));
  // }

  const onSelectionChanged = (e) => {
    const selectedRows = e.api?.getSelectedRows();
    setSelectedRows(selectedRows);
    const errors = errorList.filter(
      (error) => error.field !== 'manufactureSelect'
    );
    setErrorList([...errors]);
  };

  React.useEffect(() => {
    if (errorList.length > 0) {
      tabHighLigther('/quarterlyPayment', true);
    } else {
      tabHighLigther('/quarterlyPayment', false);
    }
  }, [JSON.stringify(errorList)]);
              
  // remove no data error msg
  React.useEffect(() => {
    dispatch(setSearchInput({ errorMessages: [] }));
  }, [ planType, planTypeList, fullScreenView, rebateProgram, reportQuarter, manufactureList, checkboxValues.isAllManufacturersSelected, checkboxValues.isBalanceDueThreshold]);

  // double click on mfg
  const cellClickedListener = (e) => {
    setSelectedRows(e?.data);
    handleSearchClick(null, true, [e?.data]);
  };
   const [gridApi, setGridApi] = React.useState(null);
   useEffect(() => {
  if (!gridApi || !manufactureList?.length || checkboxValues?.isAllManufacturersSelected) return;

  const selectedRowsInGrid = gridApi.getSelectedRows();
  if (selectedRowsInGrid?.length > 0) return;

  const firstNode = gridApi.getDisplayedRowAtIndex(0);
  if (firstNode) {
    firstNode.setSelected(true);

    const firstRowData = firstNode.data;
    setSelectedRows([firstRowData]);
    onRowSelect([firstRowData]);
  }
}, [gridApi, manufactureList, checkboxValues?.isAllManufacturersSelected]);


useEffect(() => {
  if (
    checkboxValues?.isAllManufacturersSelected ||
    !gridApi ||
    !manufactureList ||
    manufactureList.length === 0
  ) {
    return;
  }

  const alreadySelected = gridApi.getSelectedRows();
  if (alreadySelected?.length > 0) return;

  const firstNode = gridApi.getDisplayedRowAtIndex(0);
  if (firstNode) {
    firstNode.setSelected(true);

    setSelectedRows([firstNode.data]);
    onRowSelect([firstNode.data]);
  }
}, [gridApi, manufactureList, checkboxValues?.isAllManufacturersSelected]);

  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />

      <CustomSeparator
        parent1="Summary Reports"
        parent2="Quarterly Payment Report"
      />
      <DisplayErrorMessages errorMessages={errorList?.map((l) => l.message)} />
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-4 frr-two-col-radio">
                <RadioGroupComponent
                  data-testid="quarterly-payment-plan-type"
                  id="filter-plan-by-radio-btn-action"
                  labelName="Plan Type"
                  required
                  optionList={radioList || []}
                  defaultValue={planType}
                  filterAction={(value) => {
                    setPlanType(value);
                    setRebateProgram('-1');
                    const errors = errorList.filter(
                      (error) => error.field !== 'noData'
                    );
                    setErrorList([...errors]);
                  }}
                  className="log-batch-filter-radio frr-checkInvoiceRadio"
                />
              </div>
              <div className="col-4 frr-one-col-radio">
                {/* <RadioGroupComponent
                  data-testid="quarterly-payment-report-quarter-option"
                  id="filter-plan-by-radio-btn-action"
                  labelName="Report Quarter Option"
                  required
                  optionList={reportQuarterOption || []}
                  defaultValue={reportQuarter}
                  filterAction={(value) => setReportQuarter(value)}
                  className="log-batch-filter-radio frr-checkInvoiceRadio"
                /> */}
                <fieldset
                  data-testid="radio-box-component"
                  className={clsx('radioBtnGroup custom-fieldset h-100')}
                >
                  <legend className="same-font-family">
                    Report Quarter Option
                    <span className="mandatory">*</span>
                  </legend>
                  <div className="sub-radio no-margin">
                    <FormControl>
                      <RadioGroup
                        row
                        name="rpt-qtr-opt-row-radio-buttons-group"
                        defaultValue={reportQuarter}
                        value={reportQuarter}
                        data-testid="radio-box-group-control"
                        onChange={(e) => setReportQuarter(e.target.value)}
                      >
                        <FormControlLabel
                          value="All"
                          control={<Radio />}
                          label="All"
                          data-test="radio-all"
                        />
                        <FormControlLabel
                          value="DRAMS Invoice Start Quarter"
                          control={<Radio />}
                          label="DRAMS Invoice Start Quarter"
                          data-test="radio-Selected"
                        />
                        <FormControlLabel
                          value="Earliest Quarter for Drug Details"
                          control={<Radio />}
                          label="Earliest Quarter for Drug Details"
                          data-test="radio-Selected"
                          disabled={checkboxValues?.isAllManufacturersSelected}
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </fieldset>
              </div>
              <div className="col-4">
                <Fieldset label="Report Balance Due Threshold">
                  <div className="filter-checkbox">
                    <FormControlLabel
                      control={
                        <>
                          <div style={{ width: 210, marginLeft: 5 }}>
                            Use Report Balance Due Threshold:
                          </div>
                          <Checkbox
                            color="primary"
                            onChange={(e) => {
                              setCheckboxValues({
                                ...checkboxValues,
                                isBalanceDueThreshold:
                                  !checkboxValues?.isBalanceDueThreshold,
                              });
                              setIsThreshold(
                                checkboxValues?.isBalanceDueThreshold
                              );
                            }}
                            checked={checkboxValues?.isBalanceDueThreshold}
                          />
                        </>
                      }
                    />
                  </div>
                </Fieldset>
              </div>
            </div>

            <div className="row" style={{ marginTop: 15 }}>
              <div className="col-4">
                <>
                  <SelectBoxComponent
                    data-testid="request-quarterly-payment-rebate-program"
                    id="filter-plan-by-radio-btn-action"
                    label="filter-plan-by-radio-btn-action"
                    labelName="Rebate Program"
                    required
                    select
                    selectedOne
                    optionList={selectList || []}
                    defaultValue={rebateProgram}
                    filterAction={(value) => {
                      setRebateProgram(value);
                      const errors = errorList.filter(
                        (error) => error.field !== 'rebateProgram'
                      );
                      setErrorList([...errors]);
                    }}
                    isError={
                      errorList.filter(
                        (error) => error.field === 'rebateProgram'
                      ).length
                    }
                  />
                </>
              </div>
              <div className="col-4">
                <Fieldset
                  label="Manufacturers"
                  isError={
                    errorList.filter(
                      (error) => error.field === 'manufactureSelect'
                    ).length > 0
                  }
                >
                  <div className="filter-checkbox">
                    <FormControlLabel
                      control={
                        <>
                          <div
                            style={{
                              width: 175,
                              marginLeft: 5,
                            }}
                          >
                            All Manufacturers:
                          </div>
                          <Checkbox
                            data-testid="request-quarterly-payment-all-manufacturers"
                            color="primary"
                            onChange={async (e) => {
                              setCheckboxValues({
                                ...checkboxValues,
                                isAllManufacturersSelected:
                                  !checkboxValues?.isAllManufacturersSelected,
                              });
                              const errors = errorList.filter(
                                (error) => error.field !== 'manufactureSelect'
                              );
                              setErrorList([...errors]);
                              if (
                                !checkboxValues?.isAllManufacturersSelected &&
                                reportQuarter ===
                                  'Earliest Quarter for Drug Details'
                              )
                                setReportQuarter('All');
                              const elem = document.getElementById('abc');
                              if (
                                elem &&
                                checkboxValues.isAllManufacturersSelected
                              ) {
                                //setTimeout(() => {
                                   await Promise.resolve();
                                  elem.scrollIntoView();
                                //}, 1000);
                              }
                            }}
                            checked={checkboxValues?.isAllManufacturersSelected}
                          />
                        </>
                      }
                    />
                  </div>
                </Fieldset>
              </div>
            </div>
            <div className="row" style={{ marginTop: 30 }}>
              <div className="btn-wrapper col-12">
                <Button
                  data-testid="qtr-payment-butn-test"
                  onClick={handleSearchClick}
                  className="btn btn-success btn-search float-right"
                >
                  <SVGComponent iconName="Icon-search" /> Search
                </Button>
              </div>
            </div>
          </>
        )}
        <div className="row" id="abc" style={{ marginTop: 15 }}>
          <>
            {/* {manufacturerError !== "" && (
              <div style={{ fontSize: 12, color: "red" }}>
                {manufacturerError}
              </div>
            )} */}
            {!checkboxValues?.isAllManufacturersSelected && (
              <div className="unallocated" style={{ width: '100vw' }}>
                <TableGridWithFeatures
                  onSelectionChanged={onSelectionChanged}
                  ref={gridRef}
                    gridCall={(params) => {
                    setGridApi(params.api);
                  }}
                  gridHeight={viewPortHeight_355}
                  columnDefs={ManufactureTableHead}
                  rowData={manufactureList}
                  rowSelection="multiple"
                  rowMultiSelectWithClick
                  data-testid="onEditingStopped"
                  enterMovesDown
                  showResetFilter={false}
                  suppressCellFocus
                  hideTotalCount={false}
                  exportFile
                  fileName="Manufacturer List"
                  fullScreenView={fullScreenView}
                  onSelect={(e) => onRowSelect(e.api?.getSelectedRows())}
                  cellClickedListener={cellClickedListener}
                  handleFullScreenViewClick={changeFullScreenView}
                  frameworkComponents={{
                    TextBoxRender: (cellInfo) => {
                      const name = cellInfo?.value;

                      if (name && name.length > 30) {
                        return (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="labeler-tooltip">{name}</Tooltip>
                            }
                          >
                            <div>{name && `${name.substring(0, 30)}...`}</div>
                          </OverlayTrigger>
                        );
                      }
                      return <div>{name}</div>;
                    },
                  }}
                />
              </div>
            )}
          </>
        </div>
      </div>
    </div>
  );
};
export default RequestQuarterlyPayment;
